import { apiPath } from '@helpers/pathHelper';
import { useCallback, ReactElement } from 'react';

type RenderProps = {
  onClick: () => void;
};

type DownloadWrapperProps = {
  campaignId: number;
  flexibleReportRequestId: number;
  render: (props: RenderProps) => ReactElement;
};

export const DownloadWrapper = (props: DownloadWrapperProps) => {
  const { campaignId, flexibleReportRequestId } = props;

  const onClick = useCallback(() => {
    window.open(
      apiPath(
        `/api/v3/campaigns/${campaignId}/flexible_report_requests/${flexibleReportRequestId}/flexible_report.csv`
      ),
      '_blank'
    );
  }, [campaignId, flexibleReportRequestId]);

  return props.render({ onClick });
};
